import React, { useContext } from 'react';
import cn from 'classnames';
import { Button } from '@ferris/react';
import { CardContent } from '@ferris/react/components/cards';
import { ModalContext } from '../Context';
import { PropertyNotFoundModalProptypes } from '../properties';

const PropertyNotFoundModal = (props) => {
    const {
        propertyNotFoundHandler
    } = useContext(ModalContext);

    const {
        titlePropertyNotFound,
        descriptionPropertyNotFound,
        ctaConfirmPropertyNotFound
    } = props;

    return (
        <CardContent
            separatorBottom={false}
            separatorTop={false}
            classes={cn('competitor-url-modal')}
        >
            <p><b>{titlePropertyNotFound}</b></p>
            <p>{descriptionPropertyNotFound}</p>
            <Button
                onClick={propertyNotFoundHandler}
                htmlButtonType="button"
                type="primary"
                data-wdio="ppnf-competitor-url-button"
                id="ppnf-competitor-url-button"
            >
                {ctaConfirmPropertyNotFound}
            </Button>
        </CardContent>
    );
};

PropertyNotFoundModal.propTypes = PropertyNotFoundModalProptypes;

export default PropertyNotFoundModal;
